/* Existing Klaviyo form trigger. No collection, subscription, tracking or loader injection. */
(() => {
  if (customElements.get('mound-notes-signup')) return;

  class MoundNotesSignup extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-notes-trigger]');
      this.status = this.querySelector('[data-notes-status]');
      this.help = this.querySelector('[data-notes-help]');
      this.formId = (this.dataset.formId || '').trim();
      if (!this.button || !this.status || this.dataset.enabled !== 'true') return;
      if (!/^[A-Za-z0-9]{6}$/.test(this.formId)) {
        this.unavailable();
        return;
      }

      this.status.textContent = 'Opening the form does not subscribe you.';
      this.button.disabled = false;
      this.onClick = this.open.bind(this);
      this.onFormEvent = this.onActivity.bind(this);
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('klaviyoForms', this.onFormEvent);
    }

    disconnectedCallback() {
      window.clearTimeout(this.openTimeout);
      this.button?.removeEventListener('click', this.onClick);
      window.removeEventListener('klaviyoForms', this.onFormEvent);
    }

    unavailable() {
      this.status.textContent = 'The signup form is unavailable right now. Please try again later.';
      if (this.help) this.help.hidden = false;
    }

    open() {
      if (this.pending || this.button.disabled || this.dataset.enabled !== 'true') return;
      // Require the loaded service before using the form's native embed command.
      // A bare pre-load array must not retain a delayed request if the app is blocked.
      if (!window._klOnsite || typeof window._klOnsite.openForm !== 'function' || typeof window._klOnsite.push !== 'function') {
        this.unavailable();
        return;
      }
      this.pending = true;
      this.button.disabled = true;
      if (this.help) this.help.hidden = true;
      this.status.textContent = 'Opening the signup form…';
      this.openTimeout = window.setTimeout(() => {
        this.pending = false;
        this.button.disabled = false;
        this.unavailable();
      }, 8000);
      try {
        window._klOnsite.push(['openForm', this.formId]);
      } catch (_) {
        window.clearTimeout(this.openTimeout);
        this.pending = false;
        this.button.disabled = false;
        this.unavailable();
      }
    }

    onActivity(event) {
      // Read only the documented form identity and open/close type. Never inspect submit metadata.
      if (event.detail?.formId !== this.formId) return;
      if (event.detail.type === 'open') {
        window.clearTimeout(this.openTimeout);
        this.pending = false;
        this.opened = true;
        this.status.textContent = 'The signup form is open.';
      } else if (event.detail.type === 'close' && this.opened) {
        this.opened = false;
        this.button.disabled = false;
        this.status.textContent = 'Opening the form does not subscribe you.';
        this.button.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('mound-notes-signup', MoundNotesSignup);
})();
